import React, { Component } from "react";
import { ListGroup, ListGroupItem, Input } from "reactstrap";

import "./style.css";

export default class SelectPagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: this.props.perPage || 50,
      searchTerm: "",
      filteredOptions: [],
    };
  }

  componentDidMount() {
    const { onToggle } = this.props;
    document.addEventListener("click", (e) => {
      const name = e.target.getAttribute("data-name");

      if (name !== "select-pagination" && name !== "search") {
        onToggle(false);
      }
    });
  }

  handleScroll = (e) => {
    const { current } = this.state;

    const bottom =
      Math.round(e.target.scrollHeight - e.target.scrollTop) ===
      e.target.clientHeight;

    if (bottom) {
      this.setState({ current: current + 20 });
    }
  };

  filterOptions = (e) => {
    const value = e.target.value.toLowerCase();
    const { allOptions, lookFor } = this.props;

    const filteredOptions = allOptions.filter((item) => {
      const lookupString = item[lookFor] ?? "";

      return lookupString.toLowerCase().startsWith(value);
    });

    this.setState({ filteredOptions, searchTerm: e.target.value });
  };

  renderList = () => {
    const { filteredOptions = [], searchTerm } = this.state;
    let { allOptions, lookFor, onSelect } = this.props;
    const { current } = this.state;
    const newList = [];

    if (searchTerm) {
      allOptions = filteredOptions;
    }

    try {
      if (!allOptions) return;

      for (var i = 0; i <= current; i++) {
        if (!allOptions[i]) break;

        newList.push(allOptions[i]);
      }

      return newList.map((item) => (
        <p
          key={Math.random().toString()}
          onClick={() => onSelect(item)}
          className="p-2"
        >
          {item[lookFor]}
        </p>
      ));
    } catch (e) {
      console.log("e =>", e);
    }
  };

  getStyles = () => {
    const { errorMessage } = this.props;

    const styles = { cursor: "pointer" };

    if (!!errorMessage) {
      styles.borderColor = "#dc3545";
      styles.borderWidth = 1;
    }

    return styles;
  };

  render() {
    const {
      value = "",
      placeholder = "",
      isOpen = false,
      onToggle = function () {},
      containerClasses,
      errorMessage,
    } = this.props;
    const { searchTerm } = this.state;

    return (
      <ListGroup className={`${containerClasses}`}>
        <ListGroupItem
          data-name="select-pagination"
          className="py-2 px-3 d-flex"
          style={this.getStyles()}
          onClick={() => onToggle(!this.props.isOpen)}
        >
          <div data-name="select-pagination" className="flex-grow-1">
            {value ? (
              <p data-name="select-pagination">{value}</p>
            ) : (
              <p
                data-name="select-pagination"
                className="select-pagination-placeholder"
              >
                {placeholder}
              </p>
            )}
          </div>
          <div data-name="select-pagination">
            <img
              data-name="select-pagination"
              alt=""
              width="10px"
              src={require("../../assets/icons/down-arrow.png")}
            />
          </div>
        </ListGroupItem>
        {isOpen && (
          <ListGroupItem
            className="p-0 select-pagination-dropdown-container"
            onClick={() => null}
            onScroll={this.handleScroll}
          >
            <div className="my-2 mx-2">
              <Input
                value={searchTerm}
                data-name="search"
                onChange={this.filterOptions}
                placeholder="Search"
              />
            </div>
            <div>{this.renderList()}</div>
          </ListGroupItem>
        )}
        {!!errorMessage && (
          <p style={{ fontSize: "13px", color: "#dc3545" }}>
            This field is required
          </p>
        )}
      </ListGroup>
    );
  }
}
